import CRMService from "@/src/api/CRMService.js";
import InvoiceService from "@/src/api/InvoiceService.js";
import { entityTypes } from "@/src/constants/entityTypeConstants.js";
import { INVOICES_SLUG } from "@/src/constants/crmConstants.js";

export const updateStandardObjectField = async ({
  standardType,
  recordId,
  fieldSlug,
  newValue,
}) => {
  // Build payload in expected format: { object: { attributes: {...}, relations: {} } }
  const payload = {
    object: {
      attributes: {
        [fieldSlug]: newValue,
      },
      relations: {},
    },
  };

  // Use PATCH API for efficient partial updates
  let response;
  switch (standardType) {
    case entityTypes.LEAD:
      response = await CRMService.patchLead(recordId, payload);
      break;
    case entityTypes.CONTACT:
      response = await CRMService.patchContact(recordId, payload);
      break;
    case entityTypes.COMPANY:
      response = await CRMService.patchCompany(recordId, payload);
      break;
    case entityTypes.DEAL:
      response = await CRMService.patchDeal(recordId, payload);
      break;
    default:
      throw new Error(`Unknown standard type: ${standardType}`);
  }

  return response;
};

export const updateCustomObjectField = async ({
  slug,
  recordId,
  fieldSlug,
  newValue,
  service = null,
}) => {
  const attributes = { [fieldSlug]: newValue };

  // Invoices go through the lifecycle wrapper so status / whitelist gates run
  // server-side; throws InvoiceLockedError on 409 edit-lock.
  if (slug === INVOICES_SLUG) {
    return await InvoiceService.updateInvoice(recordId, {
      attributes,
      relations: {},
    });
  }

  return await CRMService.updateDynamicEntity(
    slug,
    recordId,
    { attributes, relations: {} },
    service,
  );
};

export const updateKanbanRecord = async ({
  isStandardObject,
  standardType,
  slug,
  recordId,
  fieldSlug,
  newValue,
  service = null,
}) => {
  if (isStandardObject) {
    return await updateStandardObjectField({
      standardType,
      recordId,
      fieldSlug,
      newValue,
    });
  } else {
    return await updateCustomObjectField({
      slug,
      recordId,
      fieldSlug,
      newValue,
      service,
    });
  }
};
